/* eslint-disable import/prefer-default-export */
import { isProduction } from 'utils/nodeEnv'

import * as T from 'types'

import { api } from './api'

export const contactUs = async (params: T.IContactSellerData) => {
  try {
    const response = await api.contactUs(params)
    if (!response.ok) throw new Error(`bad response: ${response.problem}`)

    return response.data
  } catch (error) {
    if (!isProduction()) console.error({ error })
  }
}

export const buyerInquiry = async (params: T.IContactSellerData) => {
  try {
    const response = await api.buyerInquiry(params)
    if (!response.ok) throw new Error(`bad response: ${response.problem}`)

    return response.data
  } catch (error) {
    if (!isProduction()) console.error({ error })
  }
}
